'use client';

import { locales, type Locale, defaultLocale, getMessages } from './request';

const LOCALE_COOKIE = 'NEXT_LOCALE';

export function getLocale(): Locale {
  if (typeof window === 'undefined') return defaultLocale;
  
  const stored = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${LOCALE_COOKIE}=`))
    ?.split('=')[1] as Locale | undefined;
  
  if (stored && locales.includes(stored)) {
    return stored;
  }
  
  // Try to detect from browser
  const browserLang = navigator.language.split('-')[0] as Locale;
  if (locales.includes(browserLang)) {
    return browserLang;
  }
  
  return defaultLocale;
}

export function setLocale(locale: Locale) {
  document.cookie = `${LOCALE_COOKIE}=${locale}; path=/; max-age=31536000; SameSite=Lax`;
  window.location.reload();
}

export { locales, defaultLocale, getMessages };
export type { Locale };
